/**
 * Acciones para la secciones de cotización responsabilidad
 */

/**
 * Imports
 */
import { createAction } from "redux-actions";


/**
 * Acciones
 */
// Registrar el tipo de caso de responsabilidad
export const setTipoCaso = createAction(
  'SET_TIPO_CASO'
)
// Ambos coinciden bien
export const ambosCamposCotizResp = createAction(
  "GUARDAR_COTIZACION_PROFESIONAL_CLIENTE"
);
// solo profesional
export const soloProfesionalCotizResp = createAction(
  "GUARDAR_COTIZACION_PROFESIONAL_SUCURSAL"
);
// solo institucion
export const soloInstitucionCotizResp = createAction(
  "GUARDAR_COTIZACION_INSTITUCIONAL_EMPRESA"
);

 /**
  * Funciones
  */
 // realizar la preservacion de cotizacion profesional
export const guardCotizResp = ({
  // datos cliente
  rucCli,
  nomEmpCli, // nombre empresa cliente
  provCli,
  ciuCli,
  dirPriCli, // direccion principal empresa solicitante
  cedCli,
  nomCli,
  // datos empresa
  activEmp,
  limEmp, // limite por evento y agregado anual
  factAnu, // facturacion anual
  giroNeg,
  // sucursal
  sucur,
  // instituciones
  nivAcad,
  tipInst,
  numEst,
  // idCarrito
  idCarrito,
}) => dispatch => {

  // ambos
  const ambos = {
  rucCli,
  nomEmpCli,
  provCli,
  ciuCli,
  dirPriCli,
  cedCli,
  nomCli,
  sucur,
  idCarrito,
  }
  // solo profesional
  const prof = {
    activEmp,
    limEmp,
    // ambos contienen los campos, pero informacion es distinta
    factAnu,
    giroNeg,
  }
  // solo institucion
  const inst = {
    nivAcad,
    tipInst,
    numEst,
    // ambos contienen los campos, pero informacion es distinta
    factAnu,
    giroNeg,
  }
  // dispatch
  dispatch(ambosCamposCotizResp(ambos));
  dispatch(soloProfesionalCotizResp(prof));
  dispatch(soloInstitucionCotizResp(inst));
}

// Reinicia los estados para los cotizadores de responsabilidad
// profesional y de instituciones
export const resetInitResp = () => dispatch => {
  // dispatch
  dispatch(ambosCamposCotizResp(null));
  dispatch(soloProfesionalCotizResp(null));
  dispatch(soloInstitucionCotizResp(null));
}